module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_Black-513b84ce90265ca7b6fffdb16446e80d.svg";